export default __webpack_public_path__ + "static/slider-5-e49a35e720de58faf62c33937e55a104.webp";